;(function() {
  'use strict'

  config.$inject = ["$stateProvider"];
  angular.module('app.projects', []).config(config)

  /* @ngInject */
  function config($stateProvider) {
    $stateProvider.state('projects', {
      url: '/projects?q&scope',
      params: {
        q: { dynamic: true, value: null },
        scope: { dynamic: true, value: null },
      },
      parent: 'portal',
      controller: 'Projects',
      controllerAs: '$ctrl',
      templateUrl: 'projects.html',
      title: 'Projects',
    })

    $stateProvider.state('studio-projects-deprecated', {
      url: '/studio/projects',
      redirectTo: 'projects',
    })
  }
})()
